<template>
  <SystemModeBanner />
  <!-- Check maintenance mode (public/maintenance.json, toggled via npm run maintenance:on/off) -->
  <div v-if="maintenanceMode === null" class="maintenance-loading">
    <div class="maintenance-spinner" />
  </div>
  <MaintenancePage v-else-if="maintenanceMode" />
  <RouterView v-else />
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import MaintenancePage from './components/MaintenancePage.vue'
import SystemModeBanner from './components/SystemModeBanner.vue'
import { driverSupportFirestoreService } from './services/driverSupportFirestoreService'
import { setJohannesburgEvsContext } from './utils/api'

const maintenanceMode = ref<boolean | null>(null)

function syncDevPresence() {
  driverSupportFirestoreService.syncDevSupportPresence()
}

onMounted(() => {
  setJohannesburgEvsContext()
  syncDevPresence()
  window.addEventListener('userDataUpdated', syncDevPresence)

  fetch('/maintenance.json')
    .then((r) => (r.ok ? r.json() : { enabled: false }))
    .then((data: { enabled?: boolean }) => {
      maintenanceMode.value = Boolean(data?.enabled)
    })
    .catch(() => {
      maintenanceMode.value = false
    })
})

onUnmounted(() => {
  window.removeEventListener('userDataUpdated', syncDevPresence)
})
</script>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}

.maintenance-loading {
  min-height: 100vh;
  width: 100%;
  background: var(--va-background-primary, #f5f5f5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.maintenance-spinner {
  width: 2.5rem;
  height: 2.5rem;
  border: 2px solid var(--va-primary, #154ec1);
  border-top-color: transparent;
  border-radius: 50%;
  animation: maintenance-spin 0.8s linear infinite;
}

@keyframes maintenance-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
